import anime from "animejs";
export default function() {
    const desktopNav = document.getElementById('desktop-menu-full');
    const links = document.querySelectorAll('.menu-link');
    const defaultBg = desktopNav.style.backgroundImage;
    const hamburgers = document.querySelectorAll('.hamburger');
    const mainMenuLink = document.querySelectorAll('.main-menu-link');
    const subMenuLink = document.querySelectorAll('.sub-menu-link');
    const parents = document.querySelectorAll('.menu-item-has-children');
    let ss = window.innerWidth;

    // display desktop menu on load with screen above 900px
    if(ss > 900) {
        function toggle_desktop_nav() {
            //reset bg image
            desktopNav.style.backgroundImage = '';

            hamburgers.forEach((hamburger) => {
                let toggle = hamburger.classList
                //console.log(toggle)
                if(toggle.contains("open")) {
                    // menu is open, open menu
                    desktopNav.classList.add("open");
                    let i = 0;
                    console.log(mainMenuLink.length)
                    mainMenuLink.forEach((link) => {
                        i++;
                        let delay = i * 50
                        anime({
                            targets: link,
                            opacity: 1,
                            duration: 100,
                            easing: 'linear',
                            delay: delay
                        });
                    });

                } else {
                    desktopNav.classList.remove("open");
                    mainMenuLink.forEach((link) => {
                        link.style.opacity = 0
                    });
                    subMenuLink.forEach((link) => {
                        link.style.opacity = 0
                    });
                }
            })
        }
        hamburgers.forEach((hamburger) => {
            hamburger.removeEventListener('click', toggle_desktop_nav);
            hamburger.addEventListener('click', toggle_desktop_nav);
        })

    }

    function reset_submenu_links() {
        subMenuLink.forEach((link) => {
            link.style.opacity = "0"
        })
    }

    function stagger_submenu_links(parent) {
        //alert(parent)
        let submenus = parent.querySelectorAll('.sub-menu')
        // console.log(submenus)
        submenus.forEach((submenu) => {
            let links = submenu.querySelectorAll('.sub-menu-link');
            let i = links.length
            //console.log(i)
            links.forEach((link) => {
                i++;
                let delay = i * 50
                anime({
                    targets: link,
                    opacity: 1,
                    duration: 200,
                    easing: 'linear',
                    delay: delay
                });
            });
        })
    }

    parents.forEach((parent) => {
        parent.removeEventListener('mouseover')
        parent.addEventListener('mouseleave', function(event) {
            // reset submenus to run animation again
            reset_submenu_links()
        })
        parent.addEventListener('mouseover', function(event) {
            stagger_submenu_links(parent)
        })
    })

    // display desktop menu on resize with screen above 900px;
    window.addEventListener('resize', function() {
        // reset bg image
        desktopNav.style.backgroundImage = '';
        ss = window.innerWidth;
        // console.log(ss)
        if(ss > 900) {
            function toggle_desktop_nav() {
                    hamburgers.forEach((hamburger) => {

                    let toggle = hamburger.classList
                    // console.log(toggle)
                    if(toggle.contains("open")) {
                        // menu is open, open menu
                        desktopNav.classList.add("open");
                    } else {
                        desktopNav.classList.remove("open");
                    }
                })
            }
            hamburgers.forEach((hamburger) => {
                hamburger.removeEventListener('click', toggle_desktop_nav);
                hamburger.addEventListener('click', toggle_desktop_nav);
            })
        }
    });


    links.forEach((link) => {
        link.addEventListener('mouseover', function() {
            // let parent = link.closest('.menu-item-has-children')
            // parent.querySelector('.menu-item-has-children a').classList.add('parent')
            let linkBg = link.dataset.bg;
            if(linkBg) {
                console.log(linkBg)
                linkHoverFunctions(linkBg)
            }
        });
        link.addEventListener('mouseout', function() {
            // let parent = link.closest('.menu-item-has-children')
            // parent.querySelector('.menu-item-has-children a').classList.remove('parent')
            // console.log(defaultBg)
            // linkHoverFunctionOut(defaultBg)
        });
    })

    function linkHoverFunctions(linkBg) {
        desktopNav.style.backgroundImage = ''
        desktopNav.style.backgroundImage = 'url("'+linkBg+'")'
    }   

    function linkHoverFunctionOut(linkBg) {
        desktopNav.style.backgroundImage = linkBg
    }   
}